//////////// PROJECT ENDPOINT 🎯🎯🎯🎯🎯 /////////
export const POST_PROJECT = "projects";

//////////// CHAT ENDPOINTS 💬💬💬💬💬 /////////
export const CHAT_ENDPOINTS = {
  CONVERSATIONS: "chat/conversations",
  MESSAGES: "chat/messages",
  PROJECT_CHAT: "chat/project",
  PROJECT_GROUPS: "chat/project-groups",
  DIRECT_MESSAGES: "chat/direct",
  SEND_MESSAGE: "chat/send",
  MARK_READ: "chat/mark-read",
  TYPING: "chat/typing",
  ONLINE_USERS: "chat/online-users",
  EMPLOYEES: "chat/employees",
  CREATE_DIRECT: "chat/direct/create",
  ENSURE_PROJECT_CHATS: "chat/ensure-project-chats",
  UNREAD_COUNT: "chat/unread-count",
};
